import FetchCustomObjects from './FetchCustomObjects';

export default FetchCustomObjects;
